<template>
  <div>
    <notifications></notifications>

    <base-header
      class="pb-6 pb-1 pt-5 pt-md-8 bg-gradient-custom"
      type="custom"
    ></base-header>

    <b-container fluid class="mt--4">
      <card>
        <form @submit.prevent="modificarDatosUSER">
          <b-row class="form-group">
            <label class="col-md-2 col-form-label form-control-label"
              >ID:</label
            >
            <b-col md="10">
              <BaseInput
                v-model="datosidUser"
                placeholder="Ingrese ID"
                required
                readonly
              />
            </b-col>
          </b-row>
          <b-row class="form-group">
            <label class="col-md-2 col-form-label form-control-label"
              >NOMBRE DE USUARIO:</label
            >
            <b-col md="10">
              <BaseInput
                v-model="datosnombreUser"
                type="text"
                placeholder="Ingresar nombre de usuario"
                required
              />
            </b-col>
          </b-row>
          <b-row class="form-group">
            <label class="col-md-2 col-form-label form-control-label"
              >CONTRASEÑA:</label
            >
            <b-col md="10">
              <BaseInput
                v-model="datoscontraUser"
                type="text"
                autocomplete="current-password"
                placeholder="Ingrese su contraseña"
              />
            </b-col>
          </b-row>
          <b-row class="form-group">
            <label class="col-md-2 col-form-label form-control-label"
              >Organización:</label
            >
            <b-col md="10">
              <base-input>
                <select class="form-control" v-model="selectedOrg" required>
                  <option
                    v-for="org in orgOptions"
                    :key="org.ID_ORG"
                    :value="org.ID_ORG"
                  >
                    {{ org.NAME_ORG }}
                  </option>
                </select>
              </base-input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <label class="col-md-2 col-form-label form-control-label"
              >Rol:</label
            >
            <b-col md="10">
              <base-input>
                <select class="form-control" v-model="datosrolUser">
                  <option value="1">Administrador</option>
                  <option value="2">Usuario</option>
                </select>
              </base-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <BaseButton
                type="success"
                @click="modificarDatosUSER"
                :loading="isLoading"
              >
                {{ isLoading ? "Guardando..." : "Guardar" }}
              </BaseButton>
              <BaseButton type="warning" @click="$router.push('/User')"
                >Cancelar</BaseButton
              >
            </b-col>
          </b-row>
        </form>
      </card>
    </b-container>
    <token-expired-modal :show="showTokenExpiredModal"> </token-expired-modal>
  </div>
</template>
<script>
import axios from "axios";
import Card from "../components/Cards/Card.vue";
import BaseButton from "../components/BaseButton.vue";
import BaseInput from "../components/Inputs/BaseInput.vue";
import TokenExpiredModal from "../components/TokenExpiredModal.vue";

export default {
  components: { Card, BaseButton, BaseInput, TokenExpiredModal },
  data() {
    return {
      datosidUser: "", // ID del usuario
      datosnombreUser: "", // Nombre del usuario
      datoscontraUser: "", // Contraseña del usuario
      selectedOrg: null, // ID de la organización seleccionada
      datosrolUser: 1, // Rol del usuario
      orgOptions: [], // Lista de organizaciones
      isLoading: false, // Estado de carga
      showTokenExpiredModal: false,
    };
  },
  async mounted() {
    // Cargar las organizaciones disponibles
    await this.fetchOrgOptions();

    // Si se está editando un usuario, cargar sus datos
    const userId = this.$route.params.id;
    if (userId) {
      await this.cargarDatosUsuario(userId);
    }
  },
  methods: {
    // Cargar las organizaciones desde el backend
    async fetchOrgOptions() {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          this.mostrarError("Token no presente. Usuario no autenticado.");
          return;
        }

        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/obtenerTodasLasOrgs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          this.orgOptions = response.data.data; // Cargar TODAS las organizaciones
        } else {
          this.mostrarError(
            response.data.message || "Error al cargar organizaciones"
          );
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
        this.mostrarError(
          "Error al cargar organizaciones. Verifica la conexión."
        );
      }
    },

    // Cargar los datos del usuario que se está editando
    async cargarDatosUsuario(userId) {
      const token = localStorage.getItem("token");

      if (!token) {
        this.mostrarError("Token no presente. Usuario no autenticado.");
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/obtenerDatosUSER/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          const usuario = response.data.data;
          this.datosidUser = usuario.ID_USER;
          this.datosnombreUser = usuario.NAME_USER;
          this.selectedOrg = usuario.ID_ORG;
          this.datosrolUser = usuario.ROL;
        } else {
          this.mostrarError("Error al cargar los datos del usuario.");
        }
      } catch (error) {
        this.mostrarError("Error en la solicitud: " + error.message);
      }
    },

    // Método para modificar los datos del usuario
    async modificarDatosUSER() {
      const token = localStorage.getItem("token");

      if (!token) {
        this.mostrarError("Token no presente. Usuario no autenticado.");
        return;
      }

      if (!this.datosnombreUser || !this.selectedOrg) {
        this.mostrarError("Por favor, complete todos los campos obligatorios.");
        return;
      }

      this.isLoading = true; // Activar estado de carga

      const datos = {
        NAME: this.datosnombreUser,
        ID_ORG: this.selectedOrg,
        ROL: this.datosrolUser,
      };

      // Si se ingresó una nueva contraseña, agregarla a los datos
      if (this.datoscontraUser) {
        datos.CONTRA = this.datoscontraUser;
      }

      try {
        const response = await axios.put(
          `${process.env.VUE_APP_API_URL}/modificarDatosUSER/${this.datosidUser}`,
          datos,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          this.mostrarExito("Usuario modificado correctamente.");
          this.$router.push("/User"); // Redirigir a la lista de usuarios
        } else {
          this.mostrarError("Error al modificar el usuario.");
        }
      } catch (error) {
        this.mostrarError("Error en la solicitud: " + error.message);
      } finally {
        this.isLoading = false; // Desactivar estado de carga
      }
    },

    // Método para mostrar notificaciones de éxito
    mostrarExito(mensaje) {
      this.$notify({
        type: "success",
        title: "Éxito",
        text: mensaje,
      });
    },

    // Método para mostrar notificaciones de error
    mostrarError(mensaje) {
      this.$notify({
        type: "error",
        title: "Error",
        text: mensaje,
      });
    },
    handleTokenExpired() {
      this.showTokenExpiredModal = true;
      setTimeout(() => {
        this.$router.push("/login");
      }, 3000);
    },
  },
};
</script>
